import { RequiredKeysOf } from 'type-fest'
import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent, OpalApiRequestBody } from '../../schema'

type RequestAttributes =
  OpalApiRequestBody<'CreateAssetReferenceV1'>['data']['attributes']
type RequestRelationships =
  OpalApiRequestBody<'CreateAssetReferenceV1'>['data']['relationships']

type OptionalAttributes = Omit<
  OpalApiComponent<'V3', 'asset_reference'>['attributes'],
  RequiredKeysOf<RequestAttributes>
>

const defaultAssetReferenceAttributes: OptionalAttributes = {
  asset_type: 'image',
  content_type: 'image',
  description: 'placeholder image',
  escaped_filename: 'placeholder_image.jpg',
  format: 'jpg',
  height: 1024,
  meta_data: null,
  original_url: null,
  preview_url: null,
  public_id: uuidv4(),
  width: 1024,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  legacy_id: '0',
}

export const resourceObject = ({
  attributes,
  relationships,
}: {
  attributes: RequestAttributes
  relationships: RequestRelationships
}): OpalApiComponent<'V3', 'asset_reference'> => {
  const id = uuidv4()
  const legacyId = Math.floor(Math.random() * 1000).toString()
  return {
    id: id,
    type: 'asset_reference',
    attributes: {
      ...defaultAssetReferenceAttributes,
      ...attributes,
      description:
        attributes.description ??
        defaultAssetReferenceAttributes.description ??
        null,
      legacy_id: legacyId,
    },
    relationships: {
      asset: { data: null },
      cover_asset_reference: { data: null },
      ...relationships,
    },
  }
}
